async function setDefaultProject(currentEnvironment = 'manage', projectID) {
  const url = `https://${currentEnvironment}.bizflycloud.vn`
  await fetch(`${url}/account/api/user/project/${projectID}`, { credentials: 'include', method: 'PATCH' })
}

export default {
  setDefaultProject
}
